import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidator } from 'src/app/utilities/custom-validator';
import { StylistService } from 'src/app/services/stylist.service';
import { Utilities } from '../utilities/utilities';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.page.html',
  styleUrls: ['./password-reset.page.scss'],
})
export class PasswordResetPage implements OnInit {
  public email: UntypedFormControl;
  public passwordResetForm: UntypedFormGroup;
  public resetSent: boolean = false;
  public isLoading: boolean = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private stylistService: StylistService,
    private alertCtrl: AlertController
  ) {
    this.email = new UntypedFormControl();
    this.passwordResetForm = new UntypedFormGroup({
      email: this.email,
    });
  }

  emailFocus(){
    this.email.setValidators(Validators.compose([Validators.required, Validators.maxLength(100),
      CustomValidator.validateEmail]))
  }

  ngOnInit() {}

  sendEmail() {
    if (this.passwordResetForm.valid === false) return;
    this.isLoading = true;
    this.changeDetectorRef.markForCheck();
    this.stylistService.requestPasswordReset(this.email.value).subscribe({
      next: () => {
        this.resetSent = true;
      },
      error: async (error) => {
        const alert = await this.alertCtrl.create(Utilities.wrongPasswordMessageConfig())
        alert.present();
      },
      complete: () => {
        this.changeDetectorRef.markForCheck();
        this.isLoading = false},
    });
  }
}
